import React, { useState } from "react"
import Breadcrumbs from "components/Common/Breadcrumb"
import {
  Card,
  CardBody,
  Container,
  Row,
  Col,
  Button,
  Input,
  Label,
  FormGroup,
  Form,
  FormFeedback,
} from "reactstrap"

import { useDispatch, useSelector } from "react-redux"
import { useHistory, useParams } from "react-router-dom"
import LoadingComponent from "components/Loading/LoadingComponent"
import { OtherCustomerAction } from "store/customer-resource/actions"
import { useFormik } from "formik"
import * as Yup from "yup"
import Select from "react-select"
import BranchesAction from "store/branch-resource/actions"
import { MetaTags } from "react-meta-tags"

export default function DetailOther() {
  const dispatch = useDispatch()
  const params = useParams()
  const history = useHistory()
  const store = useSelector(state => state)

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      branchId: "",
      branchName: "",
      customerName: "",
    },
    validationSchema: Yup.object({
      branchId: Yup.string().required("必須項目です。"),
      branchName: Yup.string().required("必須項目です。"),
      customerName: Yup.string().required("必須項目です。"),
    }),
    onSubmit: values => {
      if (params.id === "add") {
        dispatch(OtherCustomerAction.postData(values, callbackPost))
      } else {
        dispatch(
          OtherCustomerAction.putData({ ...values, id: params.id }, callbackPut)
        )
      }
    },
  })

  const callbackPost = () => {
    history.push("/individual-customer-management")
    validation.resetForm()
  }

  const callbackPut = () => {
    history.push("/individual-customer-management")
    validation.resetForm()
  }

  const callbackGetDetail = data => {
    validation.setValues(data)
  }

  React.useEffect(() => {
    if (params.id !== "add") {
      dispatch(
        OtherCustomerAction.getDetail({ id: params.id }, callbackGetDetail)
      )
    }
  }, [params.id])

  React.useEffect(() => {
    dispatch(BranchesAction.getOtherList())
  }, [])

  return (
    <>
      <MetaTags>
        <title>個人顧客管理 | Igarashi Trousers</title>
      </MetaTags>
      <div className="page-content" style={{ height: "750px" }}>
        <Container fluid>
          <Breadcrumbs title={"個人顧客管理"} breadcrumbList={[]} />

          <Card>
            <CardBody>
              {store.customer.detailIgarashi.loading ? (
                <LoadingComponent />
              ) : (
                <Form
                  onSubmit={e => {
                    e.preventDefault()
                    validation.handleSubmit()
                    return false
                  }}
                >
                  <Row>
                    <Col md={8}>
                      <p className="fw-bold">
                        {params.id != "add"
                          ? "個人顧客詳細"
                          : "新規個人顧客追加"}
                      </p>
                    </Col>
                    <Col className="d-flex justify-content-end">
                      {params.id != "add" && (
                        <>
                          <br />
                          <Button
                            type="button"
                            className="button me-2"
                            onClick={() =>
                              history.push(
                                `/individual-customer-management/${params.id}/history`
                              )
                            }
                          >
                            購入履歴
                          </Button>
                        </>
                      )}
                      <Button type="submit" className="button me-2">
                        保存
                      </Button>
                      <br />
                      <Button
                        type="button"
                        className="button"
                        onClick={() =>
                          history.push("/individual-customer-management")
                        }
                      >
                        キャンセル
                      </Button>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="8">
                      <FormGroup row>
                        <Label sm="3">企業名・店舗名</Label>
                        <Col sm="6">
                          <Select
                            isLoading={store.branches.otherList.loading}
                            options={store.branches.otherList.data.map(i => ({
                              value: i.id,
                              label: `${i.companyName} (${i.branchName})`,
                            }))}
                            defaultValue={{
                              value: validation.values.branchId,
                              label: validation.values.branchName,
                            }}
                            value={{
                              value: validation.values.branchId,
                              label: validation.values.branchName,
                            }}
                            onChange={e => {
                              validation.setFieldValue("branchId", e.value)
                              validation.setFieldValue("branchName", e.label)
                            }}
                          />
                          <Input
                            name="branchId"
                            className="form-control d-none"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.branchId || ""}
                            invalid={
                              validation.touched.branchId &&
                              validation.errors.branchId
                                ? true
                                : false
                            }
                          />
                          {validation.touched.branchId &&
                          validation.errors.branchId ? (
                            <FormFeedback type="invalid">
                              {validation.errors.branchId}
                            </FormFeedback>
                          ) : null}
                        </Col>
                      </FormGroup>
                      <FormGroup row>
                        <Label sm="3">名前</Label>
                        <Col sm="6">
                          <Input
                            name="customerName"
                            className="form-control"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.customerName || ""}
                            invalid={
                              validation.touched.customerName &&
                              validation.errors.customerName
                                ? true
                                : false
                            }
                          />
                          {validation.touched.customerName &&
                          validation.errors.customerName ? (
                            <FormFeedback type="invalid">
                              {validation.errors.customerName}
                            </FormFeedback>
                          ) : null}
                        </Col>
                      </FormGroup>
                    </Col>
                  </Row>
                </Form>
              )}
            </CardBody>
          </Card>
        </Container>
      </div>
    </>
  )
}
